import styled from 'styled-components';

export const Container = styled.div`
  padding: 6px 30px;

`